import React from "react";

const SDGCard = ({ url = "/sdg/sdg2.png", value = 65, onClick }) => {
  return (
    <div
      className="border border-[#50BAC1] rounded-md overflow-hidden cursor-pointer"
      onClick={onClick}
    >
      <div
        style={{
          backgroundImage: `url("${url}")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="aspect-square w-full"
      />
      <div className="p-1 text-sm text-center font-semibold">Total Score</div>
      <div className="bg-[#50BAC1] text-white text-center p-1 font-bold">
        {value}
      </div>
    </div>
  );
};

export default SDGCard;
